import { useContext } from "react";
import { SetLeftSideMenuOpen } from "../../layout/SideBarLayout";
import { V3IconSettings } from "../Icons";
import { V3Caption } from "../Typography";
import { OpenSettingsWrapper } from "./V3OpenSettings.styles";

interface V3OpenSettingsProps { }

export const V3OpenSettings = ({ }: V3OpenSettingsProps) => {
    const setLeftMenuOpen = useContext(SetLeftSideMenuOpen);

    return <OpenSettingsWrapper
        onClick={() => setLeftMenuOpen(true)}
    >
        <div>
            <V3IconSettings size={23} strokeWidth={"0.9"} />
        </div>
        <div>
            <V3Caption><strong>Settings</strong></V3Caption>
        </div>
    </OpenSettingsWrapper>
}